import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface DialogErrorProps {
  onClose: () => void;
  open: boolean;
  content?: string;
  isViewOrder?: boolean;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 480,
        width: "100%"
      },
      "& .MuiBackdrop-root": {
        backgroundColor: "transparent"
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 30,
        textAlign: "center",
        whiteSpace: "pre-wrap"
      },
      "& .MuiDialogActions-root": {
        justifyContent: "center",
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    btnAction: {
      height: 48,
      width: 120
    }
  }),
  { name: "CustomerBlockDialog" }
);

const CustomerBlockDialog: React.FC<DialogErrorProps> = ({
  onClose,
  open,
  content,
  isViewOrder
}) => {
  const intl = useIntl();
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      disableScrollLock={true}
    >
      <DialogContent>
        <MyTypography variant={"body2"}>
          {content ||
            intl.formatMessage({
              defaultMessage:
                "Customer รายนี้ถูก Block ไม่สามารถสร้างคำสั่งซื้อได้"
            })}
        </MyTypography>
      </DialogContent>
      <DialogActions disableSpacing={true}>
        {!isViewOrder ? (
          <Button
            color={"primary"}
            variant={"contained"}
            className={classes.btnAction}
            onClick={onClose}
          >
            <FormattedMessage defaultMessage={"ปิด"} />
          </Button>
        ) : (
          <>
            <Button
              color={"primary"}
              variant={"outlined"}
              className={classes.btnAction}
              onClick={onClose}
            >
              <FormattedMessage defaultMessage={"ยกเลิก"} />
            </Button>
            <Button
              color={"primary"}
              variant={"contained"}
              className={classes.btnAction}
              onClick={onClose}
            >
              <FormattedMessage defaultMessage={"ยืนยัน"} />
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomerBlockDialog;
